import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import {observer, inject} from 'mobx-react';
import mainLogo from '../../assets/tapingo@2x.png';
import mainLogo2 from '../../assets/phone1.png';
import androidStoreLogo from '../../assets/googlePlay@2x.png';
import appleStoreLogo from '../../assets/appStore@2x.png';


const hallListPanelWrapper = {
    "minHeight": "1080px",
    "height": "100vh",
    "width": "55%",
    "minWidth": "530px",
    "float": "left",
    "backgroundColor": "rgb(227, 89, 16)",
};

const foodCourtName = {
    "fontFamily": "GraphikSemiBold",
    "fontSize": "5vh",
    "letterSpacing": "2px",
    "margin": "auto",
    "width": "60%",
    "textAlign": "center",
    "textOverflow": "ellipsis",
    "whiteSpace": "wrap",
};

const mainLogoStyle = {
    "margin": "auto",
    "width": "40%",
};

const getTheAppWrapper = {
    "margin": "auto",
    "width": "35%"
};

const androidStoreLogoWrapper = {
    "width" : "45%",
    "float": "left"
};

const appleStoreLogoWrapper = {
    "width" : "45%",
    "float": "right"
};

@inject('RootStore')
@observer
export default class HallInfoPanel extends Component {
    render() {
        let promo = this.props.RootStore.configStore.promo;
        promo = promo !== '' ? promo : undefined;

        return (
            <div style={hallListPanelWrapper} >
                {promo ? <img src={promo} alt="" height="100%" width="100%"/> :
                <Flexbox height="100%" flexDirection="column">
                    <Flexbox width="100%" height="6%">
                    </Flexbox>
                    <Flexbox width= "100%" height="12%">
                        <div style= {mainLogoStyle}>
                            <img src= {mainLogo} alt="" width="100%"/>
                        </div>
                    </Flexbox>
                    <Flexbox width="100%" height="2%">
                    </Flexbox>
                    <Flexbox swidth= "100%" height="11.5%">
                        <div style={foodCourtName}>
                            {this.props.RootStore.hallStore.foodCourtName}
                        </div>
                    </Flexbox>
                    <Flexbox width="100%" height="6%">
                    </Flexbox>
                    <Flexbox width="100%" height="41%" flexDirection="row">
                        <Flexbox width="15%"></Flexbox>
                        <Flexbox width="75%">
                            <img src={mainLogo2} alt="" width="100%"/>
                        </Flexbox>
                        <Flexbox width="10%"></Flexbox>
                    </Flexbox>
                    <Flexbox width="100%" height="5%"> </Flexbox>
                    <Flexbox width="100%" height="8%">
                        <div style={getTheAppWrapper}>
                            <div style={androidStoreLogoWrapper}>
                                <img src={androidStoreLogo} alt="" width="100%"/>
                            </div>
                            <div style={appleStoreLogoWrapper}>
                               <img src={appleStoreLogo} alt="" width="100%"/>
                            </div>
                        </div>
                    </Flexbox>
                </Flexbox>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/hall_info_panel/hall_info_panel_wide.jsx